import { mainDrawerComponents } from '@/constants';
import { iconSvgs } from '@/constants/drawer';
import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import { fetchWithRewrites } from '@/utils/fetchWithRewrites';
import { DarkMode, LightMode } from '@mui/icons-material';
import { Box, Button, Drawer, Stack, Tooltip, Typography } from '@mui/material';
import { useNavigate, usePath } from 'raviger';
import { useEffect } from 'react';
import AuthButton from '../AuthButton';

interface LeftDrawerProps {
  drawerWidth: string | number;
}

function LeftDrawer({ drawerWidth }: LeftDrawerProps): React.ReactNode {
  const isNavBarDrawerOpen = useAlchemystStoreForAi(
    (store) => store.isCommandBarOpen
  );
  const currentTheme = useAlchemystStoreForAi((store) => store.theme);
  const drawerComponents = useAlchemystStoreForAi(
    (store) => store.drawerComponents
  );
  const setStoreState = useAlchemystStoreForAi((store) => store.setStoreState);

  const navigate = useNavigate();
  const pathname = usePath();

  const handleFilteredComponents = async () => {
    const authStatusResponse = await fetchWithRewrites('/api/auth/status');

    if (authStatusResponse.ok) {
      const authStatus = await authStatusResponse.json();
      console.log('Auth status: ', authStatus);
      const userScope: string = authStatus.data?.userType ?? 'customer';

      console.log('User scope: ', userScope);

      const permittedComponents: (typeof mainDrawerComponents)[0]['id'][] = [
        'context',
        'traces',
        'converse',
        'settings',
      ];

      let filteredComponents: typeof mainDrawerComponents = [];

      if (userScope === 'b2c') {
        filteredComponents = mainDrawerComponents.filter((component) => {
          return permittedComponents.includes(component.id);
        });
      } else {
        filteredComponents = mainDrawerComponents;
      }

      console.log('Filtered components: ', filteredComponents);

      setStoreState({ drawerComponents: filteredComponents });
    }
  };

  useEffect(() => {
    handleFilteredComponents();
  }, []);
  // useEffect(() => {
  //   setStoreState({ drawerComponents: filteredMainDrawerComponents });
  // }, [setStoreState]);

  const renderDrawerComponents = (
    components: typeof mainDrawerComponents,
    paddingLeft = 2
  ) => {
    return components.map((drawerComponent, index) => (
      <Box
        key={`menu-option-${index}`}
        onClick={() => navigate(drawerComponent.path)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          // paddingLeft: paddingLeft,
          paddingY: 1,
          paddingX: 1,
          marginY: 2,
          gap: 2,
          borderRadius: 2,
          cursor: 'pointer',
          transition: '0.2s',
          width: '100%',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.1)',
          },
          ...(pathname === drawerComponent.path && currentTheme === 'dark'
            ? {
                background: 'rgba(255, 255, 255, 0.1)',
              }
            : {}),
          ...(pathname === drawerComponent.path && currentTheme === 'light'
            ? {
                background: 'rgba(0, 0, 0, 0.1)',
              }
            : {}),
        }}
      >
        <Tooltip title={drawerComponent.name}>
          <Typography
            sx={{
              marginX: 1,
              fontWeight: 'semibold',
              fontSize: 24,
            }}
          >
            {/* {drawerComponent.name.charAt(0)} */}
            {iconSvgs[drawerComponent.id]}
          </Typography>
        </Tooltip>
        {drawerComponent.children &&
          renderDrawerComponents(drawerComponent.children, paddingLeft + 2)}
      </Box>
    ));
  };

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: drawerWidth,
        alignItems: 'center',
        flexShrink: 0,
        height: '100vh',
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: 'border-box',
          border: '3px solid',
          borderRadius: 2,
          background:
            currentTheme === 'dark'
              ? 'linear-gradient(320deg, #000000 0%, #0A0A0A 100%)'
              : 'linear-gradient(320deg, #ff9a3520 1.52%, #00000000 90.82%)',
          borderImageSource:
            'linear-gradient(270deg, #5A5A5A20 1.52%, #00000000 90.98%)',
          borderImageSlice: 1,
        },
      }}
      open={isNavBarDrawerOpen}
    >
      <Stack
        spacing={2}
        alignItems={'center'}
        alignContent={'center'}
        alignSelf={'center'}
        display={'flex'}
        justifyItems={'center'}
        direction={'column'}
        justifyContent={'space-between'}
      >
        <Stack
          spacing={1}
          display={'flex'}
          direction={'column'}
          justifyContent={'space-between'}
          alignContent={'center'}
          alignItems={'start'}
          sx={{
            scrollBehavior: 'smooth',
            overflowX: 'hidden',
            overflowY: 'auto',
          }}
        >
          {renderDrawerComponents(drawerComponents)}
        </Stack>
        <Box sx={{ marginY: 'auto' }} />
        <Stack
          spacing={2}
          sx={{
            bottom: '3vh',
            position: 'absolute',
            justifyItems: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="text"
            color={currentTheme === 'dark' ? 'inherit' : 'primary'}
            sx={{
              borderRadius: 100,
              // marginX: 2,
            }}
            onClick={() => {
              setStoreState({
                theme: currentTheme === 'dark' ? 'light' : 'dark',
              });
              setStoreState({
                theme: currentTheme === 'dark' ? 'light' : 'dark',
              });
            }}
          >
            {currentTheme === 'dark' ? <LightMode /> : <DarkMode />}
          </Button>
          <AuthButton />
        </Stack>
      </Stack>
    </Drawer>
  );
}

export default LeftDrawer;
